import React from 'react';
import { QueryClient, QueryClientProvider } from "react-query";
import { Routes } from "./components/App/Routes/Routes";
import { A2HSProvider } from "./contexts/A2HSContext";
import { AuthProvider } from "./contexts/AuthContext";
import { GlobalDataProvider } from './contexts/GlobalDataProvider';
import { GlobalFilterProvider } from "./contexts/GlobalFilterProvider";
import { PageContentProvider } from "./contexts/PageContentProvider";

//Amplify.configure(AwsConfigAuth);
const queryClient = new QueryClient();

function NovaVideowall() {

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <A2HSProvider>
          <PageContentProvider>
            <GlobalFilterProvider>
              <GlobalDataProvider>
                <Routes />
              </GlobalDataProvider>
            </GlobalFilterProvider>
          </PageContentProvider>
        </A2HSProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default NovaVideowall;
